import { ArrowLeft, ArrowRight } from "lucide-react";
import React from "react";

const Table = ({
  data,
  columns,
  rowsPerPage = 5,
  currentPage,
  setCurrentPage,
}) => {
  // Calculate the subset of data to display on the current page

  // Render the table
  return (
    <div className="flex flex-col">
      <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-greyish">
                <tr>
                  {columns?.map((column) => (
                    <th
                      key={column.id}
                      scope="col"
                      className={`px-6 py-3 text-left text-[14px] leading-[16px] font-medium text-gray-500 tracking-wider ${column.width}`}
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {!data?.transactions?.length ? (
                  <tr>
                    <td colSpan={columns.length}>
                      <div className="flex flex-col items-center justify-center py-16 bg-white ">
                        <p className="text-gray-500 text-base">
                          No transactions found
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  data?.transactions?.map((row, index) => (
                    <tr key={index}>
                      {columns?.map((column) => (
                        <td
                          key={column.id}
                          className={`px-6 py-4 whitespace-nowrap ${column.width}`}
                        >
                          {column.render ? (
                            column.render(row[column.id], row)
                          ) : (
                            <div className="text-[12px] leading-[16px] font-medium text-gray-900">
                              {row[column.id]}
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                )}

                {data?.transactions?.length > 0 && (
                  <tr>
                    <td colSpan={columns.length}>
                      <div className="flex px-3 py-4  justify-between ">
                        {currentPage !== 1 ? (
                          <div
                            className="px-4 flex gap-2  text-gray-400 rounded-md mr-2 hover:cursor-pointer "
                            onClick={() => setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            <ArrowLeft />
                            Previous
                          </div>
                        ) : (
                          <div className="px-4 flex gap-2  text-gray-400 rounded-md mr-2 hover:cursor-not-allowed">
                            <ArrowLeft />
                            Previous
                          </div>
                        )}
                        <div className="px-4 text-base flex gap-2  text-gray-400 rounded-md mr-2">
                          Page {currentPage} of{" "}
                          {Math.ceil((data?.count || 0) / rowsPerPage)}
                        </div>
                        {data?.hasNext ? (
                          <div
                            className="px-4 flex gap-2 text-gray-400 rounded-md mr-2 cursor-pointer "
                            onClick={() => setCurrentPage(currentPage + 1)}
                          >
                            Next <ArrowRight />
                          </div>
                        ) : (
                          <div className="px-4 flex gap-2 text-gray-400 rounded-md mr-2 hover:cursor-not-allowed">
                            Next <ArrowRight />
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
